import React, { createContext, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import localStorageHelper from './localStorageHelper';

const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        // Load language from localStorage if available
        const savedLanguage = localStorageHelper.getItem("currentLang") || "en"; // Default to English
        i18n.changeLanguage(savedLanguage);
    }, [i18n]);

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        localStorageHelper.setItem("currentLang", lang); // Persist selected language
    };

    return (
        <TranslationContext.Provider value={{ t, i18n, changeLanguage }}>
            {children}
        </TranslationContext.Provider>
    );
};

export const useLang = () => useContext(TranslationContext);
